import React, {FC, ReactElement} from 'react';

import {Trans} from '../../libs/shared/core/src/helpers/internationalization/react';
import {PermissionDeniedReasonsEnum} from '../../src/helpers/permissionHelpers';

/*
 * Props.
 */

export interface PermissionDeniedProps {
  reason: PermissionDeniedReasonsEnum;
}

/*
 * Component.
 */

const reasons: {[K in PermissionDeniedReasonsEnum]: ReactElement} = {
  [PermissionDeniedReasonsEnum.ADMINISTRATOR_DISABLED]: (
    <Trans id="permission-disabled-administrator">Your administrator disabled this action</Trans>
  ),
  [PermissionDeniedReasonsEnum.OFFLINE]: (
    <Trans id="permission-disabled-offline">Not available while offline</Trans>
  ),
  [PermissionDeniedReasonsEnum.BULK_UNSUPPORTED]: (
    <Trans id="permission-disabled-bulkaction">Cannot do this action in bulk</Trans>
  ),
  [PermissionDeniedReasonsEnum.BULK_UNSUPPORTED_REFINEMENTS]: (
    <Trans id="permission-disabled-bulkaction-refinement">
      Bulk actions aren&apos;t supported with conversation list filters. Try making a view with this filter to
      run bulk actions.
    </Trans>
  ),
  [PermissionDeniedReasonsEnum.MESSAGE_SENDING]: (
    <Trans id="permission-disabled-message-sending">Not available until message delivered</Trans>
  ),
};

export const PermissionDenied: FC<PermissionDeniedProps> = (props) => reasons[props.reason];
